/**
 * @generated SignedSource<<07306351e0d4342ef23a84743ca2a406>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteAppTPayload",
        "kind": "LinkedField",
        "name": "deleteAppTByAppId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AppT",
            "kind": "LinkedField",
            "name": "appT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AppDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteAppTPayload",
        "kind": "LinkedField",
        "name": "deleteAppTByAppId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AppT",
            "kind": "LinkedField",
            "name": "appT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7ebf0758521f88755df564aa589a3fad",
    "id": null,
    "metadata": {},
    "name": "AppDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation AppDeleteMutation(\n  $input: DeleteAppTByAppIdInput!\n) {\n  deleteAppTByAppId(input: $input) {\n    appT {\n      appId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "e9a63c3b3aaa2df63526ba2d81bf4325";

module.exports = node;
